// @flow

/**
 * Module dependencies.
 */

import { compose, defaultProps } from 'recompose';
import { ifProp, prop } from 'styled-tools';
import { setStylesProp } from 'client/styles';
import InlineSVG from 'svg-inline-react';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  color: string,
  icon: string,
  responsive: boolean,
  size: string,
  styles: string
};

/**
 * `Wrapper` component.
 */

const Wrapper = styled.span`
  color: ${(props: Object): string => props.color};
  display: inline-block;
  max-width: ${(props: Object): string => props.size};
  width: ${ifProp('responsive', '100%', prop('size'))};

  ${setStylesProp};
`;

/**
 * `Icon` component.
 */

function Icon(props: Props): React$Element<*> {
  const { color, icon, responsive, size, styles } = props;

  return (
    <Wrapper
      color={color}
      responsive={responsive}
      size={size}
      styles={styles}
    >
      <InlineSVG src={require(`client/assets/svg/${icon}.svg`)} />
    </Wrapper>
  );
}

/**
 * Export `Icon`.
 */

export default compose(
  defaultProps({
    color: 'currentColor',
    responsive: false,
    size: '24px',
    styles: ''
  })
)(Icon);



// WEBPACK FOOTER //
// ../src/client/components/core/icon/index.js